import React from "react";
import {
    Heading,
    ListItem,
    List,
    Text
} from "spectacle";
import Button from '../components/Button';

const OurSolutionHowItWorks = () =>
    <div>
        <Heading size={6} textColor="secondary" caps>
            Our Solution
        </Heading>
        <Text textSize={30} textColor="primary">
            How it works
        </Text>
        <List ordered textColor="secondary" style={{ paddingLeft: '25px', listStylePosition: 'outside' }}>
            <ListItem textSize={25}>Seller meets with prospect</ListItem>
            <ListItem textSize={25}>Seller uploads their slides (PDF, PPTX, etc.)</ListItem>
            <ListItem textSize={25}>Seller curates slides with personalized messages and call-outs (Dear Joe, thanks for a great meeting… Make sure to look at this slide)</ListItem>
            <ListItem textSize={25}>Sintel.AI gives seller a unique, trackable, and short URL </ListItem>
            <ListItem textSize={25}>Every time the prospect opens the presentation or shares it, the seller gets real-time notifications and can track individual slide behavior</ListItem>
            <ListItem textSize={25}>Sintel.AI perpetually analyzes, optimizes, and recommends which slides upcoming and existing prospects</ListItem>
        </List>
    </div>

export default OurSolutionHowItWorks;




// WEBPACK FOOTER //
// ./src/slides/OurSolutionHowItWorks.js